import createIcon from '../../createIcon';

/**
 * @component @name HowToVote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTMuMDAwM0gxNy4zMkwxNS4zMiAxNS4wMDAzSDE3LjIzTDE5IDE3LjAwMDNINUw2Ljc4IDE1LjAwMDNIOC44M0w2LjgzIDEzLjAwMDNINkwzIDE2LjAwMDNWMjAuMDAwM0MzIDIxLjEwMDMgMy44OSAyMi4wMDAzIDQuOTkgMjIuMDAwM0gxOUMyMC4xIDIyLjAwMDMgMjEgMjEuMTEwMyAyMSAyMC4wMDAzVjE2LjAwMDNMMTggMTMuMDAwM1pNMTcgNy45NTAyOEwxMi4wNSAxMi45MDAzTDguNTEgOS4zNjAyOEwxMy40NiA0LjQxMDI5TDE3IDcuOTUwMjhaTTEyLjc2IDIuMjkwMjlMNi4zOSA4LjY2MDI4QzYgOS4wNTAyOCA2IDkuNjgwMjggNi4zOSAxMC4wNzAzTDExLjM0IDE1LjAyMDNDMTEuNzMgMTUuNDEwMyAxMi4zNiAxNS40MTAzIDEyLjc1IDE1LjAyMDNMMTkuMTEgOC42NjAyOEMxOS41IDguMjcwMjkgMTkuNSA3LjY0MDI5IDE5LjExIDcuMjUwMjlMMTQuMTYgMi4zMDAyOUMxMy43OCAxLjkwMDI5IDEzLjE1IDEuOTAwMjkgMTIuNzYgMi4yOTAyOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HowToVote = createIcon('HowToVote', [
  [
    'path',
    {
      d: 'M18 13.0003H17.32L15.32 15.0003H17.23L19 17.0003H5L6.78 15.0003H8.83L6.83 13.0003H6L3 16.0003V20.0003C3 21.1003 3.89 22.0003 4.99 22.0003H19C20.1 22.0003 21 21.1103 21 20.0003V16.0003L18 13.0003ZM17 7.95028L12.05 12.9003L8.51 9.36028L13.46 4.41029L17 7.95028ZM12.76 2.29029L6.39 8.66028C6 9.05028 6 9.68028 6.39 10.0703L11.34 15.0203C11.73 15.4103 12.36 15.4103 12.75 15.0203L19.11 8.66028C19.5 8.27029 19.5 7.64029 19.11 7.25029L14.16 2.30029C13.78 1.90029 13.15 1.90029 12.76 2.29029Z',
      key: '1ld3cd',
    },
  ],
]);

export default HowToVote;
